import {useCallback, useMemo, useState, useEffect} from 'react'
import {InputAdornment} from '@mui/material'
import {StyledFilledInput, StyledFormControl, StyledInput, StyledSearchIcon} from './Styles'
import debounce from 'lodash.debounce'
import PropTypes from 'prop-types'
import theme from '../../../themes'

const SearchPanel = ({
  searchTerm,
  setSearchTerm,
  placeholder = 'Search',
  width,
  variant = 'standard',
  marginRight = 'auto'
}) => {
  const [inputValue, setInputValue] = useState(searchTerm || '')

  useEffect(() => {
    setInputValue(searchTerm || '')
  }, [searchTerm])

  const updateSearchTerm = useCallback(
    (searchTerm) => {
      setSearchTerm(searchTerm)
    },
    [setSearchTerm]
  )
  const updateDebouncedSearchTerm = useMemo(() => debounce(updateSearchTerm, 1000), [updateSearchTerm])
  const handleOnChange = useCallback(
    (e) => {
      const newValue = e.target.value
      setInputValue(newValue)
      updateDebouncedSearchTerm(newValue)
    },
    [updateDebouncedSearchTerm]
  )

  const InputElement = variant === 'filled' ? StyledFilledInput : StyledInput
  return (
    <StyledFormControl variant={variant} sx={{width, marginRight}}>
      <InputElement
        placeholder={placeholder}
        onChange={handleOnChange}
        value={inputValue}
        disableUnderline={variant === 'filled'}
        endAdornment={
          <InputAdornment position="end">
            <StyledSearchIcon />
          </InputAdornment>
        }
        inputProps={{
          style: {
            color: theme.palette.common.grey6
          }
        }}
      />
    </StyledFormControl>
  )
}

SearchPanel.propTypes = {
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
  placeholder: PropTypes.string,
  width: PropTypes.string,
  variant: PropTypes.string,
  marginRight: PropTypes.string
}

export default SearchPanel
